import { Modal, Button, Typography, Select, Space, Tag, Row, Input, Col, Divider, Table, Image, Tooltip } from "antd";
import { CloseOutlined, LockFilled } from "@ant-design/icons";
import { useState } from "react";
import { showMessage } from "../Utils/message";
import { extractOriginalFileName, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from "./CommonFun";
import { Button as UploadButton, IconButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AuthService from "../auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
const { Text } = Typography;
const { TextArea } = Input;
const Auth = new AuthService();

const LockPackingButton = ({ selectedRouteDetails, setLockStatuses, lockStatuses, notPackedBy }) => {
    const layoutDispatch = useLoadingDispatch()
    const [modalVisible, setModalVisible] = useState(false);
    const [notes, setNotes] = useState("");

    const [files, setFiles] = useState([]);
    const [currentItemFiles, setCurrentItemFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = useState([]);

    const submitImage = (e) => {
        handleSubmitImage(e, setFiles, setCurrentItemFiles)
    }

    const handleOk = async () => {
        if (currentItemFiles?.length < 1) return showMessage('error', 'Add at least one image')

        const dataToSend = {
        route_status_id: selectedRouteDetails?.id,
            notes: notes,
            files: currentItemFiles,
        }

        console.log(dataToSend); 
        showLoading(layoutDispatch);
        const url = '/route/lock-route-packing';

        try {
            const res = await Auth.fetch(url, {
                method: 'POST',
                body: JSON.stringify(dataToSend),
            });
            if (res?.ack) {
                setLockStatuses({
                        ...lockStatuses,
                        packed: !lockStatuses?.packed
                    })
                const uploadPromises = []
                if (files.length > 0) {
                    console.log('files upload ', files);

                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'route-packing', selectedRouteDetails?.id)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);
                setModalVisible(false);
                setNotes('');
        setCurrentItemFiles([])
        setFiles([])



            } else {
                showMessage('error', res?.message);
                hideLoading(layoutDispatch)

            }
        } catch (err) {
            showMessage('error', 'Something went wrong');
            hideLoading(layoutDispatch)

        }
         finally {
          hideLoading(layoutDispatch)
        }
    };

    const handleCancel = () => {
        setModalVisible(false);
        setNotes('');
        setCurrentItemFiles([])
        setFiles([])
    };

    return (
        <>
            <Button
                danger
                icon={<LockFilled />}
                onClick={() => {
                    if(notPackedBy) return showMessage('error', 'Cannot lock route packing. All pallets must be locked.')
                    setModalVisible(true)

                }}
            >
                Lock Packing
            </Button>

            <Modal
                title="Are you sure to lock packing?"
                // centered
                width={'85vw'}
                open={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Lock"
                cancelText="Cancel"
                okButtonProps={{ size: "large" }}
                style={{ top: 40 }}
                cancelButtonProps={{ size: "large" }}
                afterClose={() => {
                    setNotes("");
                    setFiles([]);
                    setCurrentItemFiles([]);
                    setDeletedFiles([]);
                }}
                footer={[
                    <Button key="cancel" size="large" onClick={() => setModalVisible(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="lock"
                        type="primary"
                        danger
                        icon={<LockFilled />}
                        size="large"
                        onClick={handleOk}
                    >
                        Lock
                    </Button>
                ]}
            >
                <Divider style={{ margin: '1px 1px' }} />
                <>
                    <Row style={{ marginTop: '5px' }} gutter={[16, 16]}>
                        <Col xs={24}>
                            <span>
                                Notes:
                            </span>
                            <TextArea
                                value={notes}
                                onChange={(e) => { setNotes(e.target.value) }}
                                placeholder='Notes.'
                                autoSize={{ minRows: 1, maxRows: 6 }}
                           
                            />

                        </Col>
                    </Row>
                    <div style={{ marginBottom: 4 }}>
                        <UploadButton
                            component="label"
                            variant="contained"
                            sx={{ marginTop: "10px" }}
                            startIcon={<CloudUploadIcon />}
                        >
                            Add files
                            <input
                                type="file"
                                hidden
                                multiple
                                capture
                                accept="image/*, video/*"
                                onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
                                onChange={(e) => {
                                    const myfiles = e.target.files;

                                    if (myfiles.length > 10) {
                                        showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                                        e.target.value = "";
                                    } else {
                                        submitImage(e);
                                    }
                                }}
                            />
                        </UploadButton>
                    </div>
                    <Image.PreviewGroup>
                        {files?.length > 0 &&
                            files
                                .filter(
                                    (item) =>
                                        !files.some((file) => file.name === item)
                                )
                                .map((item) => {
                                    return (
                                        <div
                                            style={{
                                                position: "relative",
                                                marginRight: "10px",
                                                display: "inline-block",
                                            }}
                                        >
                                            <Image
                                                width={150}
                                                height={100}
                                                style={{ padding: "5px", border: "1px solid lightgrey" }}
                                                //   src={imageUrl}
                                                src={URL.createObjectURL(item.file)}

                                            />
                                            <Tooltip title="Delete">
                                                <CloseOutlined
                                                    style={{
                                                        fontSize: "30px",
                                                        position: "absolute",
                                                        right: 5,
                                                        top: 5,
                                                        color: "#c12828",
                                                    }}
                                                    onClick={() => handleDeleteFile(item.name, files, currentItemFiles, setFiles, setCurrentItemFiles)}

                                                />
                                            </Tooltip>
                                        </div>
                                    );
                                })}
                    </Image.PreviewGroup>

                </>
            </Modal>
        </>
    );
};

export default LockPackingButton;
